// Counts down to the next midnight in the shop's timezone offset (data-utc-offset, minutes).
class SCountdown extends HTMLElement {
  #timer;
  #last = {};

  connectedCallback() {
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const offset = Number(this.dataset.utcOffset) || 0;
    const nowShop = Date.now() + offset * 60000;
    const dayMs = 86400000;
    const remaining = dayMs - (nowShop % dayMs);
    const parts = {
      hours: Math.floor(remaining / 3600000),
      minutes: Math.floor((remaining % 3600000) / 60000),
      seconds: Math.floor((remaining % 60000) / 1000),
    };
    for (const [unit, value] of Object.entries(parts)) {
      const el = this.querySelector(`[data-unit="${unit}"]`);
      if (!el) continue;
      const text = String(value).padStart(2, '0');
      if (this.#last[unit] === text) continue;
      this.#last[unit] = text;
      el.textContent = text;
      el.classList.remove('flip-in');
      void el.offsetWidth;
      el.classList.add('flip-in');
    }
  }
}

customElements.define('s-countdown', SCountdown);
